<template>
  <div class="accesscontrol-banner">
    <img :src="mobileBack" alt="" />
    <div class="absolute">
      <div class="title">楼宇对讲</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/mobile/components/Experience.vue";

import mobileBack from '../../../../assets/programme/mobileBack.png'

export default {
  setup() {
    return reactive({
      mobileBack:mobileBack,
      experienceShow: false,
    })
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.accesscontrol-banner {
  position: relative;
}
.accesscontrol-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 20px;
  color: #fff;
}
.absolute .experience {
  margin-top: 16px;
  color: #fff;
  border: 1px solid #fff;
  text-align: center;
  cursor: pointer;
  width: 78px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
